import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
const MouReport = (props) => {
  const [state, setState] = useState([]);
  const [responsemessage, setresponsemessage] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [inputs, setInputs] = useState({});
  const [countryOptions, setCountryOptions] = useState([]);
  const fetchCountries = async () => {
    try {
      Api.get("api/countries/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setCountryOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const loadData = async () => {
    let countryId = inputs.countryId;
    if (countryId === undefined || countryId === "") {
      countryId = 0;
    }
    let fromDate = inputs.fromDate;
    if (fromDate === undefined || fromDate === "") {
      fromDate = null;
    }
    let toDate = inputs.toDate;
    if (toDate === undefined || toDate === "") {
      toDate = null;
    }
    let statusId = inputs.statusId;
    if (statusId === undefined || statusId === "") {
      statusId = 0;
    }
    fetchData(countryId, fromDate, toDate, statusId);
  };
  const handleInputChange = (event) => {
    const { name, type, value, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;

    setInputs((inputs) => ({
      ...inputs,
      [name]: ["categoryId", "statusId", "wardId"].includes(name)
        ? parseInt(inputValue, 10)
        : inputValue,
    }));
  };

  const fetchData = (countryId, fromDate, toDate, statusId) => {
    setresponsemessage("");
    setState([]);
    let url =
      "api/reports/mou?countryId=" +
      countryId +
      "&fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&statusId=" +
      statusId;
    Api.get(url)
      .then(function (response) {
        if (response.data.length == 0) {
          setresponsemessage("No data found");
        }
        setState(response.data);
      })
      .catch(function (error) {})
      .then(function () {
        // always executed
      });
  };
  const convertTimestampToDate = (timeStamp) => {
    return new Date(timeStamp).toLocaleDateString("en-US");
  };
  const fetchMouStatus = async () => {
    try {
      Api.get("api/mouStatus/getAll?page=0&size=100")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setStatusOptions(data.mouStatus);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    fetchData(0, null, null, 0);
    fetchCountries();
    fetchMouStatus();
  }, []);

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: printRef, // ✅ new API for v3+
    documentTitle: "My PDF Document",
  });
  const MyComponentToPrint = React.forwardRef((props, ref) => (
    <div className="row" ref={ref}>
      <div className="col-sm-12">
        <h5 className="text-center">Ministry of Tourism and Wildlife</h5>
        <h5 className="text-center">National Tourism Service Portal</h5>
        <h5 className="text-center">MOU Report</h5>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col">Signed Date </th>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
              <th scope="col">Country</th>
              <th scope="col">Date</th>
              <th scope="col">Actual Start Date</th>
              <th scope="col">Actual End Date</th>
            </tr>
          </thead>
          <tbody>
            {state.map((k) => {
              return (
                <tr>
                  <td>{k.id}</td>
                  <td>{k.signedDate}</td>
                  <td>{k.name}</td>
                  <td>{k.status}</td>
                  <td>{k.country}</td>
                  <td>{k.date}</td>
                  <td>{k.actualStartDate}</td>
                  <td>{k.actualEndDate}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4">DATE: {convertTimestampToDate(Date.now())} </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="col-sm-2"></div>
    </div>
  ));
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">MOU Report</li>
      </ol>
      <h1 class="page-header mb-3">MOU Report</h1>
      <div style={{ backgroundColor: "white" }}>
        <hr />

        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-3">
              <button
                onClick={handlePrint}
                style={{
                  padding: "10px 15px",
                  background: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                }}
              >
                Print to PDF
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <div className="form-group">
                <label htmlFor="statusId" className="font-weight-bold">
                  Select Country:
                </label>
                <select
                  className="form-control"
                  name="countryId"
                  required
                  value={inputs.countryId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Country</option>
                  {countryOptions &&
                    countryOptions.map((country) => (
                      <option key={country.countryId} value={country.countryId}>
                        {country.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label htmlFor="countyId" className="font-weight-bold">
                  From Date:
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="fromDate"
                  required
                  value={inputs.fromDate || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label htmlFor="countyId" className="font-weight-bold">
                  To Date:
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  required
                  value={inputs.toDate || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-sm-2">
              <div className="form-group">
                <label htmlFor="countyId" className="font-weight-bold">
                  Select Status:
                </label>
                <select
                  className="form-control"
                  name="statusId"
                  required
                  value={inputs.statusId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Status</option>
                  {statusOptions &&
                    statusOptions.map((ward) => (
                      <option key={ward.statusId} value={ward.id}>
                        {ward.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-sm-1">
              <div className="form-group">
                <button
                  onClick={loadData}
                  style={{
                    padding: "10px 15px",
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    marginTop: "20px",
                    borderRadius: "6px",
                  }}
                >
                  Load
                </button>
              </div>
            </div>
          </div>
          <br />
          {state.length > 0 ? (
            <div ref={printRef}>
              <MyComponentToPrint ref={printRef} />
            </div>
          ) : null}
        </div>

        <h3>{responsemessage}</h3>
      </div>
    </div>
  );
};
export default MouReport;
